import { render, staticRenderFns } from "./ConfiguracionAdicionales.vue?vue&type=template&id=022c1991&"
import script from "./ConfiguracionAdicionales.vue?vue&type=script&lang=js&"
export * from "./ConfiguracionAdicionales.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports